import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const MorningnessChartHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <Typography variant="body1" className={classes.text}>
          Displays a daily “Morningness” score, which reflects how early or late
          a client's sleep occurs. A “morning person” (a lark) gets up earlier
          and goes to bed earlier, and an “evening person” (an owl) goes to bed
          later and gets up later. Scores typically range from about -6 (more
          eveningness) to +6 (more morningness), with occasional outliers, and
          are intended to show patterns and changes over time rather than exact
          units. Shifts in this feature can suggest changes in mental health, so
          it is good to ask about any patterns that reflect notable changes. If
          the value exceeds the chart's display range, the exact value can be
          viewed on mouseover.
        </Typography>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default MorningnessChartHelpIcon
